import axiosInstance from "utils/axios-request";
import {gatewayUrl} from "config";

interface ISigninDetails {
  pan?: string;
  mobile: number;
  otp: number;
  dob: string;
}

export const doSignin = (pan: string, mobile: number, dob?: string) =>
  axiosInstance.request({
      baseURL: gatewayUrl,
      url: `/hagrid/signin-initiate/?mobile=${mobile}${pan ? `&pan=${pan}` : ""}${dob ? `&dob=${dob}` : ""}`,
      method: "get",
  });

export const verifyOtp = (signinDetails: ISigninDetails) =>
  axiosInstance.request({
      baseURL: gatewayUrl,
      url: `/hagrid/signin`,
      method: "post",
      data: signinDetails,
      headers: {
        "Content-Type": `application/json`,
      },
  });
